<template>
  <div class="notification-element kwk-banner" id="kwkBanner" v-if="isCustomerEligible">
    <div class="card-wrapper">
      <div class="content">
        <span class="banner-text">
          <div class="icons">
              <div class="banner-badge-deal"><slot name="imgBadgeNotificationDeal"></slot></div>
              <div class="banner-icon"><slot name="imgIconNotification"></slot></div>
          </div>
          <span class="inner" v-if="!hasCustomerReferrals">
            <span class="d-md-none"><slot name="txtNotificationMobileInactive"></slot></span>
            <span class="d-none d-md-inline"><slot name="txtNotificationDesktopInactive"></slot></span>
          </span>
          <span class="inner" v-else>
              <span class="d-md-none"><slot name="txtNotificationMobileActive"></slot></span>
              <span class="d-none d-md-inline"><slot name="txtNotificationDesktopActive"></slot></span>
          </span>
          <slot v-if="!hasCustomerReferrals" name="btnNotificationInactive"></slot>
          <slot v-else name="btnNotificationActive"></slot>
        </span>
        <span class="banner-img"><slot name="imgSimon"></slot></span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KwkBanner',
  data () {
    return {
      friendReferralStatus: []
    }
  },
  computed: {
    isCustomerEligible: function () {
      return this.contractState.contractTerminated === false
    },
    hasCustomerReferrals: function () {
      return this.referralCount > 0
    },
    referralCount: function () {
      return this.contractState.currentCustomerContract?.friendReferralStatus?.usedReferrals || 0
    }
  },
  props: {
    contractState: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
